module.exports = __webpack_public_path__ + "static/media/19.d5c54013.jpg";